import { render } from "./TemplateCreate.vue?vue&type=template&id=795855fc&scoped=true"
import script from "./TemplateCreate.vue?vue&type=script&lang=js"
export * from "./TemplateCreate.vue?vue&type=script&lang=js"

import "./TemplateCreate.vue?vue&type=style&index=0&id=795855fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795855fc"]])

export default __exports__